import Fragment from 'ember-data-model-fragments/fragment';
import type { Type } from '@warp-drive/core/types/symbols';
import { attr } from '@warp-drive/legacy/model';
import type { EnumValue } from '@linc-technologies/linced-common/enums/base-enum';
import type PaymentMethod from '@linc-technologies/linced-common/enums/payment-method';

// Proto: finance.DailySummaryAmount.
export default class Amount extends Fragment {
  declare [Type]: 'finance/daily-summary/amount';

  @attr('number', { defaultValue: 0 })
  declare method: EnumValue<typeof PaymentMethod> | 0;

  @attr('number', { defaultValue: 0 })
  declare amount: number;
}
